{
  "instances": {
    "sessions": {
      "label": "Sesiones",
      "attributes": "Atributos",
      "created_at": "Creado",
      "expired": "Expirado",
      "expiry": "Expiración",

      "last_accessed_at": "Último acceso",
      "loading_sessions": "Cargando sesiones...",
      "max_inactive_interval": "Intervalo de <br>Inactividad Máxima",
      "no_sessions_found": "No se encontraron sesiones",
      "session_id": "Sesión Id",
      "unlimited": "Sin límites"
    }
  }
}
